const options = {
    whiteList:{ 
        section:['class', 'style'],
        img:['src', 'alt', 'title', 'width', 'height', 'id', '_src', 'loadingclass', 'class', 'data-latex'],
      }
}
export{
    options
}